var _path, _path2, _path3, _path4, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgSystemDown = function SvgSystemDown(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 154,
    viewBox: "0 0 186 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m105 0 81 49.5V99l-81-49.5V0Z",
    fill: "url(#system-down_paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m105 154 81-49V56l-81 49v49Z",
    fill: "url(#system-down_paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105 0 26 49.5V99l79-49.5V0Z",
    fill: "url(#system-down_paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m105 154-79-49V56l79 49v49Z",
    fill: "url(#system-down_paint3_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#system-down_paint4_linear)",
    d: "M72.924 77.071 43.951 64.326"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#system-down_paint5_linear)",
    d: "M83.761 48.989 54.787 36.244"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#system-down_paint6_linear)",
    d: "M91.495 34.68 62.522 21.935"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#system-down_paint7_linear)",
    d: "m48.528 132.879-28.973-12.745"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#system-down_paint8_linear)",
    d: "M76.611 62.559 47.638 49.814"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#system-down_paint9_linear)",
    d: "m54.939 118.723-28.973-12.745"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#system-down_paint10_linear)",
    d: "M65.775 90.641 36.802 77.896"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#system-down_paint11_linear)",
    d: "M58.626 104.212 29.653 91.467"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#system-down_paint12_linear)",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    d: "M42.559 142.633 93.893 24.012"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#system-down_paint13_linear)",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    d: "M13.077 131.288 64.411 12.667"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "system-down_paint0_linear",
    x1: 255.071,
    y1: 49.224,
    x2: 55.329,
    y2: 49.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#996939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0A875"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "system-down_paint1_linear",
    x1: 145.5,
    y1: 154,
    x2: 165.427,
    y2: -33.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4B4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "system-down_paint2_linear",
    x1: 105.488,
    y1: 20.295,
    x2: 25.583,
    y2: 82.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#996939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0A875"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "system-down_paint3_linear",
    x1: 65.5,
    y1: 154,
    x2: 65.5,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "system-down_paint4_linear",
    x1: 73.991,
    y1: 75.131,
    x2: 44.617,
    y2: 62.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "system-down_paint5_linear",
    x1: 84.827,
    y1: 47.049,
    x2: 55.453,
    y2: 34.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "system-down_paint6_linear",
    x1: 92.562,
    y1: 32.74,
    x2: 63.187,
    y2: 19.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "system-down_paint7_linear",
    x1: 49.595,
    y1: 130.939,
    x2: 20.221,
    y2: 118.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "system-down_paint8_linear",
    x1: 77.678,
    y1: 60.62,
    x2: 48.303,
    y2: 47.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "system-down_paint9_linear",
    x1: 56.006,
    y1: 116.783,
    x2: 26.631,
    y2: 103.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "system-down_paint10_linear",
    x1: 66.842,
    y1: 88.702,
    x2: 37.467,
    y2: 75.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "system-down_paint11_linear",
    x1: 59.693,
    y1: 102.272,
    x2: 30.318,
    y2: 89.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "system-down_paint12_linear",
    x1: 43.462,
    y1: 146.099,
    x2: 95.135,
    y2: 21.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "system-down_paint13_linear",
    x1: 13.98,
    y1: 134.755,
    x2: 65.653,
    y2: 10.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 6.447,
    y: 6.037,
    width: 94.076,
    height: 143.226,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};
export default SvgSystemDown;